import { CART_FEEDBACK_SHOWN } from "@cart-client/constants/index";
import { getBridgeSdk } from "@swiggy-private/checkout-core";
import { STORAGE_TYPES } from "@swiggy-private/native-bridge";

export const getCartFeedbackFlag = async (): Promise<boolean | undefined> => {
    try {
        const response = await getBridgeSdk().storage({
            type: STORAGE_TYPES.GET,
            data: {
                [CART_FEEDBACK_SHOWN]: "",
            },
        });
        const cartFeedbackShownTime = response?.data[CART_FEEDBACK_SHOWN];
        if (cartFeedbackShownTime == null) {
            return Promise.resolve(true);
        }

        // checking if feedback is shown once in last 30 days
        const dateOffset = 24 * 60 * 60 * 1000 * 30; // 30 days
        if (Date.now() - Number(cartFeedbackShownTime) > dateOffset) {
            // deletes the flag
            getBridgeSdk().storage({
                type: STORAGE_TYPES.DELETE,
                data: {
                    [CART_FEEDBACK_SHOWN]: "",
                },
            });

            return Promise.resolve(false);
        }

        return Promise.resolve(true);
    } catch (_) {
        return Promise.resolve(true);
    }
};

export const updateCartFeedbackFlag = async (): Promise<void> => {
    getBridgeSdk().storage({
        type: STORAGE_TYPES.SAVE,
        data: {
            [CART_FEEDBACK_SHOWN]: String(Date.now()),
        },
    });
};
